module.exports = __webpack_public_path__ + "static/media/mirror-girl.b22d94fd.svg";